import ConfigStore from '../../services/config/BrandConfigStore'
import * as mobx from 'mobx'

const hideBrandRestriction = function ($animate, userService) {
  return {
    transclude: 'element',
    replace: true,
    priority: 601,
    restrict: 'A',
    scope: {
      hideBrandRestriction: '@'
    },
    compile: (element, attr, transclude) => ($scope, $element, $attr) => {
      mobx.when(() => !!ConfigStore.brandConfig)
        .then(() => {
          const restriction = ConfigStore.brandConfig.restrictions[$scope.hideBrandRestriction];
          if (!restriction) {
            const childScope = $scope.$new();
            transclude(childScope, function (clone) {
              $animate.enter(clone, $element.parent(), $element);
            });
          }
        })
    }
  }
}


angular.module('clientDashboardApp').directive('hideBrandRestriction', hideBrandRestriction);

